export default {
  title: 'Gana puntos y obtén recompensas',
  header: {
    pickup: 'Recogida en 5 minutos',
  },
  recommendations: {
    title: 'Recomendados',
  },
  discounts: {
    title: 'Descuentos',
    data: [
      {
        title: '+125 puntos extra',
        description: 'Valóranos en Google',
      },
      {
        title: '+{{amount}} de descuento',
        description: '+{{amount}} de descuento al pagar con el código {{code}}',
      },
    ],
    button: {
      add: '+ Añadir',
    },
  },
  rewards: {
    title: 'Recompensas y cupones',
    balance: 'Saldo',
    points: 'Puntos',
  },
};
